export const Config = {
    'images' : {
        'ext' : 'png'
    },
    'projects' : {
        'ext' : 'jpg'
    }
    
}